import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ProduceWorkRegModal from "../../../../modal/PC/stock/ProduceWorkRegModal";
import ProduceWorkDetailModal from "../../../../modal/PC/stock/ProduceWorkDetailModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';

const ProduceWork = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        search:'',
        status:''
    });
    const [userTypeModalOption, setUserTypeModalOption] = useState([]);
    const [qualityYnModalOption, setQualityYnModalOption] = useState([]);
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isDetailModalOpen, setDetailModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectProduceWorkID, setSelectProduceWorkID] = useState('');
    const [statusOption, setStatusOption] = useState([]);
    const [paramID, setParamID] = useState('');
    const [initialEditOpenDone, setInitialEditOpenDone] = useState(false);
    
    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'viewer',
                headerName: '상세',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<AssignmentIcon color={"primary"} />} onClick={() => {DetailClick(params)}} label="Viewer" />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            (MenuDeleteExistYN === "Y"?
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' ? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            { field: 'id', headerName: 'produce_work_id', width: 0, headerAlign: 'center' },
            { field: 'produce_work_number', headerName: '생산작업번호', width: 120, headerAlign: 'center', align:'center'},
            { field: 'produce_work_status', headerName: 'produce_work_status', width: 0, headerAlign: 'center'},
            { field: 'produce_work_status_name', headerName: '생산작업상태', width: 120, headerAlign: 'center', align:'center'},
            { field: 'produce_work_start_datetime', headerName: '생산시작일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'produce_work_end_datetime', headerName: '생산종료일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'produce_work_item_id', headerName: 'produce_work_item_id', width: 0, headerAlign: 'center', align:'center'},
            { field: 'produce_work_item_name', headerName: '품목', width: 180, headerAlign: 'center', align:'left' },
            { field: 'produce_work_item_spec', headerName: '규격', width: 250, headerAlign: 'center', align:'left' },
            { field: 'produce_work_count', headerName: '생산작업수량', width: 120, headerAlign: 'center', align:'right' },
            { field: 'produce_work_complete_count', headerName: '정품수량', width: 100, headerAlign: 'center', align:'right' },
            { field: 'produce_work_error_count', headerName: '불량수량', width: 100, headerAlign: 'center', align:'right' },
            { field: 'update_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        produce_work_number: true,
        produce_work_status: false,
        produce_work_status_name: true,
        produce_work_start_datetime: true,
        produce_work_end_datetime: true,
        produce_work_item_id: false,
        produce_work_item_name: true,
        produce_work_item_spec: true,
        produce_work_count: true,
        produce_work_complete_count: true,
        produce_work_error_count: true,
        deleted: true,
        viewer: true,
        update_user_name: true
    });
    

    useEffect(() => {
        if (paramID && originRows.length > 0 && !initialEditOpenDone) {
            const targetRow = originRows.find(row => String(row.produce_work_id) === String(paramID));
            
            if (targetRow) {
                setSelectProduceWorkID(targetRow.produce_work_id);
                setModalTitle('생산작업 상세');
                setDetailModalOpen(true);
                setInitialEditOpenDone(true); // 한 번 열린 후에는 반복 실행되지 않도록 true로 변경
            }
        }
    }, [paramID, originRows, initialEditOpenDone]);

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            
            if(params.produce_work_id !== null && typeof params.produce_work_id !== 'undefined'){
                setParamID(params.produce_work_id);
            } else if (params.id !== null && typeof params.id !== 'undefined') {
                setParamID(params.id);
            }
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);
    
    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.status])
    
    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        axios.get('/api/p/ProduceWork/List',
            {
            params : {
              search : keyword.search,
              status : keyword.status
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.produce_work_id]) {
                    PermissionMap[row.produce_work_id] = [row.reg_user_id, row.update_user_id, row.produce_work_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });

            var array = response.data.map((item, index) => ({
                id: item.produce_work_id,
                produce_work_number: item.produce_work_number,
                produce_work_status: item.produce_work_status,
                produce_work_status_name: item.produce_work_status_name,
                produce_work_start_datetime: Moment(item.produce_work_start_datetime).format('YYYY-MM-DD HH:mm:ss'),
                produce_work_end_datetime: Moment(item.produce_work_end_datetime).format('YYYY-MM-DD HH:mm:ss'),
                produce_work_item_id: item.produce_work_item_id,
                produce_work_item_name: item.produce_work_item_name,
                produce_work_item_spec: item.produce_work_item_spec,
                produce_work_count: Number(item.produce_work_count ?? 0).toLocaleString('ko-KR'),
                produce_work_complete_count: Number(item.produce_work_complete_count ?? 0).toLocaleString('ko-KR'),
                produce_work_error_count: Number(item.produce_work_error_count ?? 0).toLocaleString('ko-KR'),
                update_user_name: item.update_user_name,
                update_flag: PermissionMap[item.produce_work_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    }

    const handleInitSelect = () => {

        //작업상태
        var array = [
            {value:'', label:'전체'}
            ,{value:'E', label:'작업완료'}
            /*,{value:'C', label:'작업취소'}*/
        ];
        setStatusOption(array);
        
        // 담당자 유형
        axios.get('/api/Common/CodeDetailList')
        .then((response) => { 

            var user_type_array_modal = [];
            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0020'){
                    user_type_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }
            }

            var quality_yn_array_modal = [
                {value:'Y', label:'Y'}
                ,{value:'N', label:'N'}
            ];

            setQualityYnModalOption(quality_yn_array_modal);
            setUserTypeModalOption(user_type_array_modal);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const handleInit = () => {
        setKeyword({
            search: '',
            status: ''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            produce_work_number: true,
            produce_work_status: false,
            produce_work_status_name: true,
            produce_work_start_datetime: true,
            produce_work_end_datetime: true,
            produce_work_item_id: false,
            produce_work_item_name: true,
            produce_work_item_spec: true,
            produce_work_count: true,
            produce_work_complete_count: true,
            produce_work_error_count: true,
            deleted: true,
            viewer: true,
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('생산작업 등록');
    };
    
    const DetailClick = (object) => {
        setDetailModalOpen(true);
        setModalTitle('생산작업 상세');
        setSelectProduceWorkID(object.row.id);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '생산작업번호 '+object.row.produce_work_number+' 삭제',
            html : '생산작업번호 '+object.row.produce_work_number+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/ProduceWork/Delete', new URLSearchParams({
                    delete_produce_work_id: object.row.id,
                    folder: 'ProduceWork'
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '생산작업번호 '+object.row.produce_work_number+' 삭제 완료',
                            text: '정상적으로 생산작업번호 '+object.row.produce_work_number+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .then(function () {
                    appStore.setLoading(false);
                });
            }
        });
    };

    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };
    
    const handleRegSuccessSave = (regID) => {
        setModalTitle('생산작업 상세');
        setRegModalOpen(false);
        handleView();
        
        Swal.fire({
            title: '생산 등록 완료',
            text: '정상적으로 생산이 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setDetailModalOpen(true);
            setSelectProduceWorkID(Number(regID));
        });
    };

    const handleExcel = () => {
        var filename = '생산관리'
        axios.get('/api/p/ProduceWork/Excel',
        {   
            params : { search : keyword.search, status : keyword.status, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y' && (
                        <ProduceWorkRegModal
                        onClose={() => {
                            setRegModalOpen(false);
                        }}
                        title={modalTitle}
                        handleRegSuccessSave={handleRegSuccessSave}
                        userTypeModalOption={userTypeModalOption}
                        qualityYnModalOption={qualityYnModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isDetailModalOpen && (
                        <ProduceWorkDetailModal
                        onClose={() => {
                            setDetailModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectProduceWorkID}
                        originRows={originRows.filter(row => String(row.produce_work_id) === String(selectProduceWorkID))}
                        handleView={handleView}
                        userTypeModalOption={userTypeModalOption}
                        qualityYnModalOption={qualityYnModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default ProduceWork;
